// Library imports
import { Radio, Tooltip } from 'antd';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { FC, useEffect, useState } from 'react';
// Local imports
import useQuery from 'hooks/useQuery';
import { removeOnClickBubble } from 'utils';
import useVisible from '../Shared/useVisible';
import Button from '../../Common/Components/Button';
import { CONTACTS_BY_FILTER_ENUM, getDisplayLabel, getSelectedLabel, getSelectedType } from './utils';
// Icon imports
import Sort from '../../../assets/img/icons/Sort.svg';
import BackArrow from '../../../assets/img/icons/BackArrow.svg';
import { ReactComponent as DownAngle } from '../../../assets/img/icons/DownAngle.svg';
import { ReactComponent as SearchCross } from '../../../assets/img/icons/SearchCross.svg';

interface IEmailsByFilterComponent {
  tab?: string;
  accountId: number;
  searchedText: string;
  filterLabelProp: string;
  isFromAccounts?: boolean;
  isEmailEngagement?: boolean;
  emailsByFilter: string;
  setEmailsByOpens?: (val: string) => void;
  setEmailsByClicks?: (val: string) => void;
  setEmailsByFilter: (val: string) => void;
}
const DEFAULT_PAGE_LIMIT = 20;
const re = /^[0-9\b]+$/;
let numValue = '';
let prevType = 0;
let prevTextValue = '';
let prevLabel = '';

const EmailsByFilterComponent: FC<IEmailsByFilterComponent> = (props: IEmailsByFilterComponent) => {
  // Props
  const {
    searchedText,
    isFromAccounts,
    accountId,
    filterLabelProp,
    isEmailEngagement,
    setEmailsByOpens,
    setEmailsByClicks,
    setEmailsByFilter,
    emailsByFilter,
  } = props;

  // Local States
  const [appliedText, setAppliedText] = useState('');
  const [isVisible2, setIsVisible2] = useState(false);
  const [appliedLabel, setAppliedLabel] = useState('');
  const [appliedFilter, setAppliedFilter] = useState(0);
  const [lessTextValue, setLessTextValue] = useState('');
  const [selectedLabel, setSelectedLabel] = useState('');
  const [selectedFilter, setSelectedFilter] = useState(0);
  const [equalTextValue, setEqualTextValue] = useState('');
  const [greaterTextValue, setGreaterTextValue] = useState('');
  const [filterLabel, setFilterLabel] = useState(filterLabelProp);
  const [lessEqualTextValue, setLessEqualTextValue] = useState('');
  const [greaterEqualTextValue, setGreaterEqualTextValue] = useState('');

  const query = useQuery();
  const history = useHistory();
  // useVisible
  const { ref, isVisible, setIsVisible } = useVisible(false);

  // Redux States

  // Component Logic

  const isParameterApplied = (parameterName: string) => {
    const selectedLabel = getSelectedLabel(parameterName) ?? '';
    return filterLabel.includes(selectedLabel);
  };

  const selectParameterFlow = (parameterName: string) => {
    prevLabel = '';
    prevTextValue = '';
    prevType = 0;
    const isApplied = isParameterApplied(parameterName);
    setSelectedLabel(parameterName);
    if (!isApplied) {
      //let user Set new params;
      clearTextValues();
      setSelectedFilter(0);
    } else {
      // show user old params
      setSelectedFilter(appliedFilter);
      setTextValueToAppliedValue(appliedFilter);
      numValue = appliedText;
    }
  };

  const getSelectedFilter = () => {
    let label = '';
    let isOpens = isFromAccounts ? selectedLabel === 'Unique Opens' : selectedLabel === 'Total Opens';
    let isClicks = isFromAccounts ? selectedLabel === 'Unique Clicks' : selectedLabel === 'Total Clicks';
    switch (selectedFilter) {
      case 1:
        label = getSelectedLabel(selectedLabel) + ' = ' + equalTextValue;
        setFilterLabel(label);
        if (isEmailEngagement) {
          isOpens && setEmailsByOpens && setEmailsByOpens('=' + equalTextValue);
          isClicks && setEmailsByClicks && setEmailsByClicks('=' + equalTextValue);
        }
        setEmailsByFilter(label);
        return label;
      case 2:
        label = getSelectedLabel(selectedLabel) + ' < ' + lessTextValue;
        setFilterLabel(label);
        if (isEmailEngagement) {
          isOpens && setEmailsByOpens && setEmailsByOpens('<' + lessTextValue);
          isClicks && setEmailsByClicks && setEmailsByClicks('<' + lessTextValue);
        }
        setEmailsByFilter(label);
        return label;
      case 3:
        label = getSelectedLabel(selectedLabel) + ' > ' + greaterTextValue;
        setFilterLabel(label);
        if (isEmailEngagement) {
          isOpens && setEmailsByOpens && setEmailsByOpens('>' + greaterTextValue);
          isClicks && setEmailsByClicks && setEmailsByClicks('>' + greaterTextValue);
        }
        setEmailsByFilter(label);
        return label;
      case 4:
        label = getSelectedLabel(selectedLabel) + ' <= ' + lessEqualTextValue;
        setFilterLabel(label);
        if (isEmailEngagement) {
          isOpens && setEmailsByOpens && setEmailsByOpens('<=' + lessEqualTextValue);
          isClicks && setEmailsByClicks && setEmailsByClicks('<=' + lessEqualTextValue);
        }
        setEmailsByFilter(label);
        return label;
      case 5:
        label = getSelectedLabel(selectedLabel) + ' >= ' + greaterEqualTextValue;
        setFilterLabel(label);
        if (isEmailEngagement) {
          isOpens && setEmailsByOpens && setEmailsByOpens('>=' + greaterEqualTextValue);
          isClicks && setEmailsByClicks && setEmailsByClicks('>=' + greaterEqualTextValue);
        }
        setEmailsByFilter(label);
        return label;
    }
  };

  const storeTextValue = () => {
    switch (selectedFilter) {
      case 1:
        setAppliedText(equalTextValue);
        break;
      case 2:
        setAppliedText(lessTextValue);
        break;
      case 3:
        setAppliedText(greaterTextValue);
        break;
      case 4:
        setAppliedText(lessEqualTextValue);
        break;
      case 5:
        setAppliedText(greaterEqualTextValue);
        break;
    }
  };
  const setTextValueToAppliedValue = (appliedFilter: number) => {
    switch (appliedFilter) {
      case 1:
        setEqualTextValue(appliedText);
        setLessTextValue('');
        setGreaterTextValue('');
        setLessEqualTextValue('');
        setGreaterEqualTextValue('');
        break;
      case 2:
        setEqualTextValue('');
        setLessTextValue(appliedText);
        setGreaterTextValue('');
        setLessEqualTextValue('');
        setGreaterEqualTextValue('');
        break;
      case 3:
        setEqualTextValue('');
        setLessTextValue('');
        setGreaterTextValue(appliedText);
        setLessEqualTextValue('');
        setGreaterEqualTextValue('');
        break;
      case 4:
        setEqualTextValue('');
        setLessTextValue('');
        setGreaterTextValue('');
        setLessEqualTextValue(appliedText);
        setGreaterEqualTextValue('');
        break;
      case 5:
        setEqualTextValue('');
        setLessTextValue('');
        setGreaterTextValue('');
        setLessEqualTextValue('');
        setGreaterEqualTextValue(appliedText);
        break;
    }
  };

  const clearTextValues = () => {
    setEqualTextValue('');
    setLessTextValue('');
    setGreaterTextValue('');
    setLessEqualTextValue('');
    setGreaterEqualTextValue('');
  };

  const clearFields = () => {
    setEqualTextValue('');
    setLessTextValue('');
    setGreaterTextValue('');
    setLessEqualTextValue('');
    setGreaterEqualTextValue('');
    setSelectedFilter(0);
    setFilterLabel(filterLabelProp);
    prevLabel = '';
    prevTextValue = '';
    prevType = 0;
    // setEmailsByFilter('');
  };

  const clear = (e?: any) => {
    e && removeOnClickBubble(e);
    setSelectedFilter(0);
    setFilterLabel(filterLabelProp);
    setEqualTextValue('');
    setLessTextValue('');
    setGreaterTextValue('');
    setLessEqualTextValue('');
    setGreaterEqualTextValue('');
    setSelectedLabel('');
    setIsVisible2(false);
    setIsVisible(false);
    setAppliedFilter(0);
    setAppliedText('');
    setEmailsByFilter('');
  };

  useEffect(() => {
    if (emailsByFilter) {
      setFilterLabel(emailsByFilter);
      if (emailsByFilter !== '') {
        prevLabel = getDisplayLabel(emailsByFilter.split(' ')[0]) ?? '';
        prevType = getSelectedType(emailsByFilter.split(' ')[1]) ?? 0;
        prevTextValue = emailsByFilter.split(' ')[2];
        setAppliedFilter(prevType);
        setAppliedLabel(prevLabel);
      }
    } else if (!emailsByFilter && filterLabel !== filterLabelProp) {
      clear();
    }
  }, [emailsByFilter]);

  useEffect(() => {
    if (isVisible === false && isVisible2 === true && filterLabel === filterLabelProp) {
      numValue = '';
      clearFields();
    }
  }, [isVisible, isVisible2]);
  return (
    <Wrapper isFromAccounts={isFromAccounts} isVisible2={isVisible2}>
      <div
        className={`dropdown-selecter ${isVisible ? 'active' : ''}`}
        onClick={() => {
          if (filterLabel === filterLabelProp) {
            setSelectedFilter(0);
            setIsVisible2(false);
            setIsVisible(!isVisible);
          } else {
            setSelectedLabel(appliedLabel);
            setSelectedFilter(appliedFilter);
            setTextValueToAppliedValue(appliedFilter);
            setIsVisible(!isVisible);
            setIsVisible2(true);
            numValue = appliedText;
          }
        }}
      >
        <Tooltip placement="top" title={filterLabel === 'Emails by' ? '' : filterLabel}>
          <div className="label">
            <img src={Sort} />
            <span className="label-eclips" id="contact-filter-selected-value">
              &nbsp; {filterLabel}
            </span>
            {filterLabel !== filterLabelProp && (
              <span className="cleaclear-search">
                <SearchCross
                  onClick={(e) => {
                    clear(e);
                    if (isEmailEngagement) {
                      setEmailsByOpens && setEmailsByOpens('');
                      setEmailsByClicks && setEmailsByClicks('');
                    }
                  }}
                />
              </span>
            )}
          </div>
        </Tooltip>
        <div className="d-flex">
          <div className="divider"></div>
          <div className="icon">
            <DownAngle />
          </div>
        </div>
      </div>
      <div ref={ref} className={`dropdown-options ${isVisible ? 'show' : ''}`}>
        {/* Toggle class "show" to show and hide dropdown */}
        <div className="dropdown-options-inner">
          <div
            className={`dropdown-wrapper contacts-by-filter-component ${isVisible2 ? 'show-part2' : ''}`}
            id={isVisible2 ? 'show-part2' : 'show-part1'}
          >
            <div className={`dropdown-top-filters`} id="show-part1-wrapper">
              <ul>
                {isFromAccounts || !isEmailEngagement ? (
                  <li
                    onClick={() => {
                      numValue = '';
                      selectParameterFlow('Unique Opens');
                      setIsVisible2(true);
                    }}
                  >
                    <label>Unique Opens</label>
                  </li>
                ) : null}
                {!isFromAccounts || !isEmailEngagement ? (
                  <li
                    onClick={() => {
                      numValue = '';
                      selectParameterFlow('Total Opens');
                      setIsVisible2(true);
                    }}
                  >
                    <label>Total Opens</label>
                  </li>
                ) : null}
                {isFromAccounts || !isEmailEngagement ? (
                  <li
                    onClick={() => {
                      numValue = '';
                      selectParameterFlow('Unique Clicks');
                      setIsVisible2(true);
                    }}
                  >
                    <label>Unique Clicks</label>
                  </li>
                ) : null}
                {!isFromAccounts || !isEmailEngagement ? (
                  <li
                    onClick={() => {
                      numValue = '';
                      selectParameterFlow('Total Clicks');
                      setIsVisible2(true);
                    }}
                  >
                    <label>Total Clicks</label>
                  </li>
                ) : null}
              </ul>
            </div>
            <div className="dropdown-v2" id="show-part2-wrapper">
              <div className="header-dropdown">
                <div
                  className="back-main"
                  onClick={() => {
                    setIsVisible2(false);
                    setIsVisible(true);
                  }}
                >
                  <img src={BackArrow} alt="<" />
                  <span className="back-label">Back</span>
                </div>
                <span className="label-dropwon-v2">Filter {isEmailEngagement ? 'Emails' : 'Contact'} where</span>
              </div>
              <div className="body-dropdown">
                <span className="main-label">{prevLabel !== '' ? prevLabel : selectedLabel}</span>
                <Radio.Group name="radiogroup" value={prevType > 0 ? prevType : selectedFilter}>
                  <ul>
                    <li>
                      <Radio
                        value={1}
                        onChange={(e) => {
                          numValue = '';
                          clearFields();
                          setSelectedFilter(1);
                        }}
                        defaultChecked={prevType === CONTACTS_BY_FILTER_ENUM.EQUALS && prevTextValue !== '' ? true : false}
                        id="equal-radio"
                      >
                        Equals
                      </Radio>
                      <input
                        className={selectedFilter === 1 || prevType === CONTACTS_BY_FILTER_ENUM.EQUALS ? '' : 'disabled'}
                        type="text"
                        value={prevType === CONTACTS_BY_FILTER_ENUM.EQUALS && prevTextValue !== '' ? prevTextValue : equalTextValue}
                        onChange={(e) => {
                          if (re.test(e.target.value) || e.target.value === '') {
                            numValue = e.target.value;
                            setEqualTextValue(e.target.value);
                            prevTextValue = '';
                          }
                        }}
                        id="equals-input"
                      />
                    </li>
                    <li>
                      <Radio
                        value={2}
                        onChange={(e) => {
                          numValue = '';
                          clearFields();
                          setSelectedFilter(2);
                        }}
                        defaultChecked={prevType === CONTACTS_BY_FILTER_ENUM.LESS && prevTextValue !== '' ? true : false}
                        id="less-radio"
                      >
                        Less than
                      </Radio>
                      <input
                        className={selectedFilter === 2 || prevType === CONTACTS_BY_FILTER_ENUM.LESS ? '' : 'disabled'}
                        type="text"
                        value={prevType === CONTACTS_BY_FILTER_ENUM.LESS && prevTextValue !== '' ? prevTextValue : lessTextValue}
                        onChange={(e) => {
                          if (re.test(e.target.value) || e.target.value === '') {
                            numValue = e.target.value;
                            setLessTextValue(e.target.value);
                            prevTextValue = '';
                          }
                        }}
                        id="less-then-input"
                      />
                    </li>
                    <li>
                      <Radio
                        value={3}
                        onChange={(e) => {
                          numValue = '';
                          clearFields();
                          setSelectedFilter(3);
                        }}
                        defaultChecked={prevType === CONTACTS_BY_FILTER_ENUM.GREATER && prevTextValue !== '' ? true : false}
                        id="greater-radio"
                      >
                        Greater than
                      </Radio>
                      <input
                        className={selectedFilter === 3 || prevType === CONTACTS_BY_FILTER_ENUM.GREATER ? '' : 'disabled'}
                        type="text"
                        value={prevType === CONTACTS_BY_FILTER_ENUM.GREATER && prevTextValue !== '' ? prevTextValue : greaterTextValue}
                        onChange={(e) => {
                          if (re.test(e.target.value) || e.target.value === '') {
                            numValue = e.target.value;

                            setGreaterTextValue(e.target.value);
                            prevTextValue = '';
                          }
                        }}
                        id="greater-then-input"
                      />
                    </li>
                    <li>
                      <Radio
                        value={4}
                        onChange={(e) => {
                          numValue = '';
                          clearFields();
                          setSelectedFilter(4);
                        }}
                        defaultChecked={prevType === CONTACTS_BY_FILTER_ENUM.LESS_OR_EQUAL && prevTextValue !== '' ? true : false}
                        id="less-or-equal-radio"
                      >
                        Less than or equal to
                      </Radio>
                      <input
                        className={selectedFilter === 4 || prevType === CONTACTS_BY_FILTER_ENUM.LESS_OR_EQUAL ? '' : 'disabled'}
                        type="text"
                        value={prevType === CONTACTS_BY_FILTER_ENUM.LESS_OR_EQUAL && prevTextValue !== '' ? prevTextValue : lessEqualTextValue}
                        onChange={(e) => {
                          if (re.test(e.target.value) || e.target.value === '') {
                            numValue = e.target.value;

                            setLessEqualTextValue(e.target.value);
                            prevTextValue = '';
                          }
                        }}
                        id="less-or-equal-input"
                      />
                    </li>
                    <li>
                      <Radio
                        value={5}
                        onChange={(e) => {
                          numValue = '';
                          clearFields();
                          setSelectedFilter(5);
                        }}
                        defaultChecked={prevType === CONTACTS_BY_FILTER_ENUM.GREATER_OR_EQUAL && prevTextValue !== '' ? true : false}
                        id="greater-or-equal-radio"
                      >
                        Greater than or equal to
                      </Radio>
                      <input
                        className={selectedFilter === 5 || prevType === CONTACTS_BY_FILTER_ENUM.GREATER_OR_EQUAL ? '' : 'disabled'}
                        type="text"
                        value={prevType === CONTACTS_BY_FILTER_ENUM.GREATER_OR_EQUAL && prevTextValue !== '' ? prevTextValue : greaterEqualTextValue}
                        onChange={(e) => {
                          if (re.test(e.target.value) || e.target.value === '') {
                            numValue = e.target.value;

                            setGreaterEqualTextValue(e.target.value);
                            prevTextValue = '';
                          }
                        }}
                        id="greater-or-equals-input"
                      />
                    </li>
                  </ul>
                </Radio.Group>
                <div className="d-flex justify-content-end ps-3 pt-3">
                  <Button
                    value="Cancel"
                    className="btn-sm-secondary me-2"
                    id="cancel-contact-filter"
                    onClick={(e: any) => {
                      if (isEmailEngagement) {
                        clear(e);
                        setEmailsByOpens && setEmailsByOpens('');
                        setEmailsByClicks && setEmailsByClicks('');
                      } else {
                        numValue = '';
                        clearFields();
                        setEmailsByFilter('');
                        setFilterLabel(filterLabelProp);
                        setIsVisible2(false);
                        setIsVisible(false);
                      }
                    }}
                  />
                  <Button
                    value="Apply"
                    className={`btn-sm-primary ${numValue === '' ? 'disabled' : ''}`}
                    id="apply-contact-filter"
                    onClick={() => {
                      setIsVisible2(false);
                      setIsVisible(false);
                      setAppliedFilter(selectedFilter);
                      setAppliedLabel(selectedLabel);
                      getSelectedFilter();
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default EmailsByFilterComponent;

const Wrapper = styled.div<{ isFromAccounts?: boolean; isVisible2?: boolean }>`
  position: relative;
  .disabled {
    pointer-events: none;
    opacity: 0.6;
  }
  .dropdown-selecter {
    border: 1px solid #dadada;
    min-width: 170px;
    background: #fff;
    border-radius: 8px;
    min-height: 36px;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
    padding-right: 2px;
    height: 38px;
    float: right;
    width: auto;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      min-width: 150px;
      height: 30px;
      min-height: 30px;
    }
    &:focus,
    &:active,
    &.active {
      box-shadow: 0 0 0 0.1rem rgb(40 167 69 / 50%);
    }
    .label {
      color: #7e7e7e;
      font-size: 16px;
      font-weight: 500;
      font-family: 'Roboto', sans-serif;
      display: flex;
      padding: 0px 0px 2px 4px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      width: calc(100% - 30px);
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 12px;
        margin-top: 2px;
      }
      img {
        margin-top: 1px;
        float: left;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: 15px;
        }
      }
      .clear-search {
        float: right;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          margin-top: -3px;
        }
      }
      .label-eclips {
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        display: block;
        float: left;
        width: 100%;
        max-width: 200px;
        @media all and ((max-width: 1280px)) {
          margin-top: 2px;
        }
      }
    }
    .divider {
      -webkit-align-self: stretch;
      -ms-flex-item-align: stretch;
      align-self: stretch;
      background-color: hsl(0, 0%, 80%);
      margin-bottom: 8px;
      margin-top: 7px;
      width: 1px;
      box-sizing: border-box;
      + .icon {
        padding: 5px 0.5rem 0.5rem 0.5rem;
        @media all and (max-width: 1280px), (max-height: 728px) {
          padding-top: 2px !important;
          padding-bottom: 3px !important;
        }
        @media all and (max-width: 1439px) and (min-width: 1281px), (-webkit-device-pixel-ratio: 1.25) {
          padding-top: 7px !important;
          padding-bottom: 7px !important;
        }
      }
    }
  }
  .dropdown-options {
    background: #fff;
    position: absolute;
    top: 40px;
    right: 0px;
    z-index: 9;
    width: ${(props) => (props.isVisible2 ? '280px' : 'auto')};
    border-radius: 8px;
    max-width: 280px;
    transition-duration: 0.5s;
    overflow: hidden;
    height: 0px;
    opacity: 0;
    box-shadow: 0px 5px 14px 0px rgb(0 0 0 / 28%);
    &.show {
      height: auto;
      opacity: 1;
    }
    .dropdown-options-inner {
      border: 1px solid #def6e6;
      box-shadow: 0 0 40px 0 rgb(0 0 0 / 28%);
      background: #fff;
      border-radius: 8px;
      float: left;
      width: 100%;
      .message-limit {
        float: left;
        width: 100%;
        padding: 15px;
        text-align: center;
        font-size: 16px;
        font-weight: 500;
        font-family: 'Roboto', sans-serif;
        color: #ffa112;
        background: #ebf5ee;
      }
      .dropdown-header {
        background: #def6e6;
        color: #27ce0a;
        font-weight: 500;
        font-size: 16px;
        line-height: 40px;
        font-family: 'Roboto', sans-serif;
        padding: 10px 16px 0 16px;
        border-radius: 8px 8px 0 0;
        float: left;
        width: 100%;
        svg {
          height: 12px;
          width: 16px;
          margin-right: 12px;
        }
        .sub-header {
          border: 1px solid #dadada;
          padding: 10px;
          background: #f7f7f7;
          float: left;
          margin: 10px -17px 0 -17px;
          width: calc(100% + 34px);
        }
      }
      .dropdown-wrapper {
        float: left;
        width: 100%;
        max-height: 450px;
        overflow: auto;
        &::-webkit-scrollbar {
          display: none;
        }
        &.show-part2 {
          .dropdown-top-filters {
            display: none;
          }
          .dropdown-v2 {
            display: block;
          }
        }
        .dropdown-v2 {
          display: none;
          .header-dropdown {
            background: #f7f7f7;
            border-bottom: 1px solid #dadada;
            padding: 16px 16px 12px 16px;
            float: left;
            width: 100%;
            .back-main {
              cursor: pointer;
              float: left;
              width: 100%;
              img {
                width: 15px;
              }
              .back-label {
                padding-left: 8px;
                color: #424b50;
                font-size: 16px;
                font-weight: 500;
                font-family: 'Roboto', sans-serif;
              }
            }
            .label-dropwon-v2 {
              color: #7e7e7e;
              font-size: 12px;
              font-weight: 500;
              font-family: 'Roboto', sans-serif;
              padding-left: 24px;
              margin-top: -5px;
              float: left;
              display: block;
            }
          }
          .body-dropdown {
            padding: 0px 8px 12px 15px;
            float: left;
            width: 100%;
            .main-label {
              color: #424b50;
              font-size: 14px;
              font-weight: 500;
              font-family: 'Roboto', sans-serif;
              margin-top: 10px;
              float: left;
              width: 100%;
            }
            ul {
              margin: 0;
              padding: 0;
              li {
                padding: 5px 0;
                margin: 0;
                display: flex;
                justify-content: space-between;
                width: 100%;
                .ant-radio-wrapper {
                  span {
                    color: #7e7e7e;
                    font-size: 14px;
                    font-weight: 500;
                    font-family: 'Roboto', sans-serif;
                    letter-spacing: -0.35px;
                  }
                }
                input[type='text'] {
                  float: right;
                  width: 65px;
                  border-radius: 13px;
                  border: 1px solid #dadada;
                  color: #7e7e7e;
                  font-size: 16px;
                  font-weight: 500;
                  font-family: 'Roboto', sans-serif;
                  line-height: 16px;
                  padding: 2px 8px;
                  &:focus,
                  &:active,
                  &:focus-visible {
                    outline: none;
                    border: 1px solid #dadada;
                    outline-offset: 0px;
                    border-color: inherit;
                    -webkit-box-shadow: none;
                    box-shadow: none;
                    background: transparent;
                    box-shadow: 0 0 0 0.1rem rgb(40 167 69 / 50%);
                  }
                }
              }
            }
          }
        }
      }
      .dropdown-top-filters {
        padding: 14px 0px 14px 24px;
        float: left;
        width: 100%;
        h4 {
          color: #424b50;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Roboto', sans-serif;
          margin: 0;
          line-height: 40px;
          width: 100%;
          float: left;
        }
        ul {
          width: 100%;
          float: left;
          display: block;
          margin: 0;
          li {
            list-style-type: none;
            margin: 5px 0;
            width: 100%;
            display: block;
            float: left;
            label {
              font-family: 'Roboto', sans-serif;
              color: #7e7e7e;
              font-size: 16px;
              font-weight: 500;
              cursor: pointer;
              display: block;
              padding: 0px 0;
              float: left;
              &:hover {
                color: #27ce0a;
              }
              .ant-checkbox-wrapper {
                display: inline-block;
                float: left;
                &::after {
                  display: none;
                }
              }
              > div {
                float: left;
                margin: 8px 12px;
              }
            }
          }
        }
      }
      .dropdown-body {
        padding: 0 16px;
        width: 100%;
        float: left;
        ul {
          width: 100%;
          float: left;
          padding: 20px 20px 20px 0px;
          list-style-type: none;
          li {
            width: 100%;
            float: left;
            padding: 0;
            margin: 0;
            .label {
              font-family: 'Roboto', sans-serif;
              color: #7e7e7e;
              font-size: 14px;
              font-weight: 500;
              cursor: pointer;
              display: block;
              padding: 5px 0;
              line-height: 30px;
              white-space: nowrap;
              text-overflow: ellipsis;
              word-break: keep-all;
              overflow: hidden;
              width: 165px;
              min-width: 165px;
              transition-duration: 0.5s;
            }
            .tick {
              opacity: 0;
              transition-duration: 0.5s;
              margin-right: 13px;
              float: left;
              svg {
                height: 12px;
                width: 16px;
                vertical-align: baseline;
              }
            }
            .current {
              color: #27ce0a;
              opacity: 1;
            }
          }
        }
      }
    }
  }
`;
